// =============================================================================
// All route (page/component under development phase using development layout with developer and debuging tools.
// Will be moved out on development complete.
//
// =============================================================================

export default [
  {
    path: '/dev',
    component: () => import('@/developing/index.vue'),
    children: [
      //
      {
        path: 'classroom-stats/:classroomId',
        name: 'dev-classroom-stats',
        props: true,
        component: () => import('@/developing/views/pages/ClassroomStats/dev.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.class-stats.page-title', default: "สถิติห้องเรียน"},
              active: true
            }
          ],
          pageTitle: 'sections.class-stats.page-title',
        },
      },
      //
      {
        path: 'liveclass',
        name: 'dev-liveclass',
        props: true,
        component: () => import('@/developing/views/pages/LiveClass/dev.vue'),
        meta: {
          breadcrumb: [
            {title: 'LiveClass', url: '/'},
            {
              title: { i18n: 'sections.liveclass.page-title', default: "Live Class"},
              active: true
            }
          ],
          pageTitle: 'sections.liveclass.page-title',
        },
      },
      //
      {
        path: 'advisor',
        name: 'dev-advisor',
        props: true,
        component: () => import('@/developing/views/pages/Advisor/dev.vue'),
        meta: {
          breadcrumb: [
            {title: 'Advisor', url: '/'},
            {
              title: { i18n: 'sections.advisor.page-title', default: "Advisor"},
              active: true
            }
          ],
          pageTitle: 'sections.advisor.page-title',
        },
      },
      // Off-route matcher for developing a single component.
      {
        path: ':filter',
        component: () => import('@/developing/views/Main/index.vue'),
        meta: {
          // rule: 'editor',
          // parent: 'email',
          no_scroll: true
        }
      },
    ]
  },
];
